import initialState from './initialState';
import Actions from './actions';

export default function global(state = initialState, action: any) {
  switch (action.type) {
    case Actions.GET_HOMEPAGENEWS_REQUEST:
      return {
        ...state,
        homepageNews: {
          ...state.homepageNews,
          loading: true,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_HOMEPAGENEWS_SUCCESS:
      return {
        ...state,
        homepageNews: {
          ...state.homepageNews,
          loading: false,
          loaded: true,
          data: [
            ...action.payload.data,
          ]
        }
      }

    case Actions.GET_HOMEPAGENEWS_ERROR:
      return {
        ...state,
        homepageNews: {
          ...state.homepageNews,
          loading: false,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_NEWS_REQUEST:
      return {
        ...state,
        news: {
          ...state.news,
          loading: true,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_NEWS_SUCCESS:
      return {
        ...state,
        news: {
          ...state.news,
          loading: false,
          loaded: true,
          data: [
            ...action.payload.data,
          ],
          ...action.payload.meta
        }
      }

    case Actions.GET_NEWS_ERROR:
      return {
        ...state,
        news: {
          ...state.news,
          loading: false,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_LASTESTNEWS_REQUEST:
      return {
        ...state,
        lastestNews: {
          ...state.lastestNews,
          loading: true,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_LASTESTNEWS_SUCCESS:
      return {
        ...state,
        lastestNews: {
          ...state.lastestNews,
          loading: false,
          loaded: true,
          data: [
            ...action.payload.data,
          ]
        }
      }

    case Actions.GET_LASTESTNEWS_ERROR:
      return {
        ...state,
        lastestNews: {
          ...state.lastestNews,
          loading: false,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_TAGS_REQUEST:
      return {
        ...state,
        tags: {
          ...state.tags,
          loading: true,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_TAGS_SUCCESS:
      return {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          loaded: true,
          data: [
            ...action.payload.data,
          ]
        }
      }

    case Actions.GET_TAGS_ERROR:
      return {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_NEWSDETAILS_REQUEST:
      return {
        ...state,
        newsDetails: {
          ...state.newsDetails,
          loading: true,
          loaded: false,
          data: {},
        }
      }

    case Actions.GET_NEWSDETAILS_SUCCESS:
      return {
        ...state,
        newsDetails: {
          ...state.newsDetails,
          loading: false,
          loaded: true,
          data: {
            ...action.payload.data,
          }
        }
      }

    case Actions.GET_NEWSDETAILS_ERROR:
      return {
        ...state,
        newsDetails: {
          ...state.newsDetails,
          loading: false,
          loaded: false,
          data: {},
        }
      }


    default:
      break;
  }
  return state
}
